import * as React from 'react';
import { useSelector } from 'react-redux';
import { BasicInfo } from '../../components/BasicInfo';
import {
  getSpecialStatusDisplay,
  getUndergroundInfo,
  getNewbuildingClassName,
  getBuilder,
  getFirstRoadInfo,
} from '../../selectors/newbuilding';
import { trackBuilderLinkClick } from './tracking';

const BUILDER_TITLE = 'Застройщик';

export function BasicInfoContainer() {
  const specialStatus = useSelector(getSpecialStatusDisplay);
  const undergrounds = useSelector(getUndergroundInfo);
  const roadInfo = useSelector(getFirstRoadInfo);
  const className = useSelector(getNewbuildingClassName);
  const builder = useSelector(getBuilder);

  const onLinkClick = React.useCallback((title: string) => {
    if (title === BUILDER_TITLE) {
      trackBuilderLinkClick();
    }
  }, []);

  const data = [
    { title: 'Сдача комплекса', value: specialStatus },
    ...(undergrounds && undergrounds[0]
      ? [{ title: 'Ближайшее метро', value: undergrounds[0].name }]
      : roadInfo
      ? [{ title: 'Ближайшее шоссе', value: `${roadInfo.name} шоссе ${roadInfo.distance} км от МКАД` }]
      : []),
    { title: 'Класс комплекса', value: className },
    ...(builder
      ? [{ title: BUILDER_TITLE, value: builder.name, logoUrl: builder.logoUrl, linkUrl: builder.profileUrl }]
      : []),
  ];

  return <BasicInfo data={data} onLinkClick={onLinkClick} />;
}
